export default {
  computed: {
    isMobile: function () {
      return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/device.js